import React from 'react';
import { Box, CircularProgress, MenuItem, Typography } from '@mui/material';
import { typography } from '../../styles/theme';

const TEXT_PRIMARY = '#D4D4D4';
const TEXT_SECONDARY = '#ABABAB';
const BORDER = '#383838';
const MENU_BG = '#242424';
/** Acción destructiva (p. ej. «Desvincular campaña»): rojo discreto del tema. */
const DANGER = '#F2B8B5';
/** Acción que todavía no se puede usar (p. ej. dueño con la cuenta sin habilitar): gris pero legible, con tooltip. */
const MUTED = '#8A8A8A';

export const ACTION_MENU_PAPER_PROPS = {
  sx: {
    bgcolor: MENU_BG,
    border: 'none',
    borderRadius: '8px',
    minWidth: '164px',
    width: '164px',
    overflow: 'hidden',
    backgroundImage: 'none',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.24), 0 6px 20px rgba(0, 0, 0, 0.18)',
    '& .MuiList-root': {
      p: 0,
    },
    '& .MuiMenuItem-root': {
      minHeight: '34px',
      height: '34px',
      display: 'flex',
      alignItems: 'center',
      px: '8px',
      py: 0,
      gap: '12px',
      color: TEXT_PRIMARY,
      bgcolor: MENU_BG,
      border: 'none',
      borderRadius: 0,
      '&:hover': { bgcolor: '#3A7877' },
      '&.Mui-disabled': {
        opacity: 0.5,
      },
    },
    // Tooltip envuelve el último item en un <span>; :last-of-type
    // omitiría el divider del item anterior (p. ej. Renombrar).
    '& .MuiMenuItem-root:not(:last-child)': {
      borderBottom: `1px solid ${BORDER}`,
    },
  },
};

export const ACTION_MENU_LIST_PROPS = { disablePadding: true };

export default function ActionMenuItem({
  icon, label, loading = false, disabled = false, onClick, danger = false, testId, muted = false,
}) {
  const tone = danger ? DANGER : muted ? MUTED : null;
  // `muted`: se ve en gris y sigue recibiendo el hover (para su Tooltip); `aria-disabled` para lectores.
  let itemSx;
  if (danger) itemSx = { '&:hover': { bgcolor: 'rgba(242,184,181,0.12) !important' } };
  else if (muted) itemSx = { cursor: 'default', '&:hover': { bgcolor: 'rgba(255,255,255,0.04) !important' } };
  return (
    <MenuItem
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      {...(muted ? { 'aria-disabled': true } : {})}
      data-muted={muted ? 'true' : undefined}
      sx={itemSx}
    >
      <Box
        sx={{
          width: '20px',
          height: '20px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: tone || TEXT_SECONDARY,
        }}
      >
        {loading ? <CircularProgress size={16} sx={{ color: TEXT_SECONDARY }} /> : icon}
      </Box>
      <Typography
        sx={{
          flex: 1,
          minWidth: 0,
          color: tone || TEXT_PRIMARY,
          fontSize: '13px',
          lineHeight: '18px',
          fontFamily: typography.fontFamily.primary,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </MenuItem>
  );
}
